export const updateCustomerInfo = (payload) => {
  return {
    type: "UPDATE_CUSTOMER_INFO",
    payload,
  };
};

export const resetCustomerInfo = () => {
  return {
    type: "RESET_CUSTOMER_INFO",
  };
};
